export const COMMON = {
  app: {
    name: 'ENSTRUCTURE',
  },
  notFound: {
    title: 'Page not found',
    description: 'This page doesn’t exist or may have been moved. Head back home to continue.',
    backHome: 'Back to home',
  },
  navigation: {
    login: 'Log in',
    logout: 'Log out',
    expandSidebar: 'Expand Sidebar',
    collapseSidebar: 'Collapse Sidebar',
    darkMode: 'Dark mode',
  },
  text: {
    close: 'Close',
    noResults: 'No Results',
    loading: 'Loading',
    pleaseWaitWhileFetching: 'Please wait while fetching data.',
    somethingWentWrong: 'Something went wrong',
    unableToLoadData: 'Unable to load data',
    failedToLoadData: 'Failed to load data',
    pleaseRefreshOrTryAgain: 'Please refresh or try again',
    retry: 'Retry',
  },
}
